import Vue from 'vue';
import { buildDelayedFunction, getSetting } from '@/helpers/tools';

Vue.mixin({
  methods: {
    $setTimeout: buildDelayedFunction(window.setTimeout, window.clearTimeout),
    $setInterval: buildDelayedFunction(window.setInterval, window.clearInterval),
    /**
     * @param   {string}  message        The message to be displayed
     * @param   {boolean} afterRedirect  Whether the message should wait redirection to be displayed
     * @param   {number}  duration       The notification duration in milliseconds.
     * @returns {Promise<any>}
     */
    $addError(message, afterRedirect = false, duration = 14000) {
      return this.$store.dispatch('appNotification/addError', {
        message,
        afterRedirect,
        duration,
      });
    },
    /**
     * @param   {string}  message        The message to be displayed
     * @param   {boolean} afterRedirect  Whether the message should wait redirection to be displayed
     * @param   {number}  duration       The notification duration in milliseconds.
     * @returns {Promise<any>}
     */
    $addSuccess(message, afterRedirect = false, duration = 7000) {
      return this.$store.dispatch('appNotification/addSuccess', {
        message,
        afterRedirect,
        duration,
      });
    },
    /**
     * @param {string} key
     * @return {any}
     */
    $setting(key) {
      return getSetting(key);
    },
  },
});
